import { ApiError } from '@commissionsight/sdk';

/**
 * AI statement setup ("train on this statement") — an app-only feature (not in the
 * public SDK), so the web app calls the endpoint directly with the session token.
 */
export interface TrainResult {
  action: 'reuse' | 'reuse_candidate' | 'build';
  signatureHash: string;
  configId: string | null;
  built: boolean;
  coverage?: { mapped: number; total: number };
  /** True when the build ran on the account's own AI key. */
  usingByok?: boolean;
}

export async function trainCarrierMapping(
  baseUrl: string,
  token: string | null,
  carrierId: string,
  file: File,
): Promise<TrainResult> {
  const form = new FormData();
  form.set('file', file);
  const res = await fetch(`${baseUrl.replace(/\/$/, '')}/carriers/${carrierId}/mapping/ai-build`, {
    method: 'POST',
    headers: token ? { authorization: `Bearer ${token}` } : undefined,
    body: form,
  });
  const text = await res.text();
  const body = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const message =
      body && typeof body === 'object' && 'title' in body
        ? String((body as { title: unknown }).title)
        : res.statusText;
    throw new ApiError(res.status, message, body);
  }
  return body as TrainResult;
}
